
import { Link ,useNavigate} from "react-router-dom";
import { useLogoutMutation } from "../Services/api";
import { toast } from 'react-toastify';
import React  from "react";
import { useDispatch } from 'react-redux';
import { userLogout } from "../redux/authSlice";
export default function ClientNav() {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const authType = localStorage.getItem('authType');

    const [logout] = useLogoutMutation();
    const logoutUser = (values) => {
        logout({ data: values })
        .unwrap()
        .then((payload) => {
            
          if (payload.status) {
            const response = {
                userDetail: null,
                isLoggedIn: false
            };
            
              dispatch(userLogout(response));

              if(authType===1){
                navigator('/admin');
              }else{
                navigator('/login');
              }
              
          } 
        })
        .catch((error) => {
            toast.error(error.data.message)
        });
      
    };
    const ToggleSidebar = () => {
        const select = (el, all = false) => {
            el = el.trim()
            if (all) {
              return [...document.querySelectorAll(el)]
            } else {
              return document.querySelector(el)
            }
          }
          select('body').classList.toggle('toggle-sidebar')
    }
    return (
        <aside id="sidebar" className="sidebar">
        <ul className="sidebar-nav" id="sidebar-nav">
            <li className="nav-item">
                <Link onClick={ToggleSidebar} to="/student-dashboard" className="nav-link collapsed">
                    <i className="bi bi-grid"></i>
                    <span>Dashboard</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link onClick={ToggleSidebar} to="/student-resources" className="nav-link collapsed">
                    <i className="bi bi-grid"></i>
                    <span>Resources</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link onClick={ToggleSidebar} to="/student-progress" className="nav-link collapsed">
                    <i className="bi bi-grid"></i>
                    <span>My Progress</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link onClick={ToggleSidebar} to="/student-course" className="nav-link collapsed">
                    <i className="bi bi-grid"></i>
                    <span>My Courses/Training</span>
                </Link>
            </li>
             <li className="nav-item">
                <Link onClick={ToggleSidebar} to="/mock-exam-result" className="nav-link collapsed">
                    <i className="bi bi-grid"></i>
                    <span>Mock Exam Result</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link onClick={ToggleSidebar} to="/student-profile" className="nav-link collapsed">
                    <i className="bi bi-grid"></i>
                    <span>Profile Setting</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link onClick={ToggleSidebar} to="/student-password-update" className="nav-link collapsed">
                    <i className="bi bi-grid"></i>
                    <span>Password Setting</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link onClick={ToggleSidebar} to="/student-contact-us" className="nav-link collapsed">
                    <i className="bi bi-grid"></i>
                    <span>Contact Us</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link onClick={ToggleSidebar} to="/student-message" className="nav-link collapsed">
                    <i className="bi bi-grid"></i>
                    <span>Tutor Support</span>
                </Link>
            </li>
            <li className="nav-item">
                <Link onClick={ToggleSidebar} to="/online-payment" className="nav-link collapsed">
                    <i className="bi bi-grid" ></i>
                    <span>Online Payment</span>
                </Link>
            </li>
           
            <li className="nav-item">
                <Link onClickCapture={logoutUser} className="nav-link collapsed">
                   <i className="bi bi-box-arrow-right"></i>
                        <span>Sign Out</span>
                </Link>
            </li>
            
        </ul>
        </aside>
    );
}
